import React from 'react';

import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { PreviewCard, Calendar, Icon, Button } from '@weezevent/nacre';

import Style from './listPreview.module.css';
import i18n from 'i18next';
import { PreviewEmpty } from './../../components/previewEmpty';
import useAppContext from '../../../../context/useAppContext';

function isSameDay(a, b) {
    let _a = moment(a);
    let _b = moment(b);
    if (!moment.isMoment(_a) || !moment.isMoment(_b)) return false;
    // Compare least significant, most likely to change units first
    // Moment's isSame clones moment inputs and is a tad slow
    return _a.date() === _b.date() && _a.month() === _b.month() && _a.year() === _b.year();
}

export function ListPreview({ anchorSelected = null, onChangeAnchorSelected = () => {}, datesWithSessions = {}, selectable = false }) {
    const { t } = useTranslation();
    const locale = i18n.language;
    const [{ event_timezone }] = useAppContext();

    //important for set locale moment used by Calendar
    moment.locale(locale);

    const dateNowLocalized = React.useMemo(() => {
        return moment.tz(moment.utc().tz(event_timezone), event_timezone).format('YYYY-MM-DD');
    }, [event_timezone]);

    const _onChangeAnchorSelected = React.useCallback(
        date => {
            let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
            //locale sv-SE for return format YYYY-MM-DD
            let linkAnchor = new Intl.DateTimeFormat('sv-SE', options).format(new Date(date));

            let anchorTarget = document.getElementById(linkAnchor);
            if (anchorTarget) {
                onChangeAnchorSelected(date);
            }
        },
        [onChangeAnchorSelected, selectable]
    );

    const nextDayFutureSessions = React.useMemo(() => {
        let dateNowLocalized = moment.tz(moment.utc().tz(event_timezone), event_timezone).format('YYYY-MM-DD');

        let nextDay = Object.keys(datesWithSessions).find(date => date > dateNowLocalized);
        return nextDay ? moment(nextDay) : null;
    }, [dateNowLocalized, datesWithSessions, event_timezone]);

    return (
        <>
            {Object.keys(datesWithSessions).length ? (
                <PreviewCard title={t('ticket.sessions.list.previewTitle')}>
                    <div className={Style['preview-card__content']}>
                        <span>
                            {nextDayFutureSessions && (
                                <div className={Style['next-day-button-container']}>
                                    <Button
                                        className={Style['next-day-button']}
                                        inverted
                                        primary
                                        fluid
                                        label={t('ticket.sessions.list.previewNextDayLabel')}
                                        onClick={() => _onChangeAnchorSelected(moment(nextDayFutureSessions))}
                                    />
                                </div>
                            )}
                            <Calendar
                                locale={locale}
                                dateSelected={anchorSelected}
                                onChange={date => _onChangeAnchorSelected(date)}
                                isDayHighlighted={day1 => Object.keys(datesWithSessions).some(day2 => isSameDay(day1, day2))}
                                isDayBlocked={day1 => !Object.keys(datesWithSessions).some(day2 => isSameDay(day1, day2))}
                            />
                            {anchorSelected && (
                                <div className={Style['anchor-selected__count']}>
                                    {t('ticket.sessions.list.countAnchorSelected', { count: datesWithSessions[anchorSelected.format('YYYY-MM-DD')] })}
                                </div>
                            )}
                        </span>
                    </div>
                </PreviewCard>
            ) : (
                <PreviewEmpty title={t('ticket.sessions.list.previewEmptyTitle')} icon={<Icon name="calendar" size="huge" />} />
            )}
        </>
    );
}
